import type { FaireCollectionEntity } from "../../entity_types/collection";

export const pbc_pdyqqzq8sn: FaireCollectionEntity = {
  token: "pbc_pdyqqzq8sn",
  type: "collection",
  name: "White Denim Essentials",
  heroImageUrl:
    "https://cdn.faire.com/fastly/9bf3beede463616d9e867e4337a5df2cb65aaeec4ea3eb9b2f7e3174f7febf86.jpeg",
  itemCount: 14,
  description: "The perfect crisp white denim for Spring and Summer!",
  brandToken: "b_d5ug42njab",
  productTokens: [],
  meta: {
    source: "api",
    importedAt: "2026-08-11T00:35:15.295Z",
    importedBy: "entity-db-import-collections",
  },
};
